"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("./styled");
const ui_1 = require("@phishtool/ui");
const analytics_1 = require("@phishtool/analytics");
const StartTrial = ({ quotePortal }) => {
    const [staticData] = (0, ui_1.useStaticState)();
    return ((0, jsx_runtime_1.jsxs)(styled_1.StyledQuoteButton, { href: `${staticData === null || staticData === void 0 ? void 0 : staticData.env.APP_HOST}/sign-up/enterprise-trial-from-quote/${quotePortal.token}`, onClick: () => (0, analytics_1.logEvent)('Portal Trial CTA Clicked', { portalId: quotePortal._id }), children: [(0, jsx_runtime_1.jsx)("span", { children: "Start free trial" }), (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: "trial", size: { width: 34, height: 36 }, alignment: "vertical" })] }));
};
exports.default = StartTrial;
